import { NetSuitePaymentType } from "../models/NetSuitePaymentType";
import { host, getRequest, patchRequest, postRequest, deleteRequest } from "./apiService";

export async function getNetSuitePaymentTypes() {
	return getRequest<NetSuitePaymentType[]>(`${host}/api/netsuitePaymentType`);
}
export async function updateNetSuitePaymentType(netsuitePaymentType: NetSuitePaymentType) {
	return patchRequest<void>(
		`${host}/api/netsuitePaymentType/${netsuitePaymentType.id}`, netsuitePaymentType
	);
}
export async function addNetSuitePaymentType(newepicType: NetSuitePaymentType) {
	const { id, ...objectWithoutId } = newepicType;
	return postRequest<NetSuitePaymentType | undefined>(
		`${host}/api/netsuitePaymentType`, objectWithoutId
	);
}
export async function deleteNetSuitePaymentType(id: number) {
	return deleteRequest(`${host}/api/netsuitePaymentType/${id}`);
}